import type { HttpClient } from '@shared/http/http-client';
import type { IInvitationRepository } from '@domain/data-contracts/invitation-repository.interface';
import type { InvitationCreateRequest } from '@domain/models/invitation.interface';

export class InvitationRepository implements IInvitationRepository {
  public constructor(private readonly http: HttpClient) {}

  public async create(orgId: string, req: InvitationCreateRequest): Promise<void> {
    await this.http.post(
      `/api/organizations/${encodeURIComponent(orgId)}/invitations`,
      {
        email: req.email,
        initialRoleId: req.initialRoleId,
        organizationName: req.organizationName,
      },
    );
  }
}
